export default __webpack_public_path__ + "images/160ab4ff91c5c715e928f2a93d3c0424-city_town_small.webp";